<template>
  <!-- 退货申请，洛奥 -->
  <div class="returnList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="getTableData('refresh')"
      :crumbsList="['订单管理', $route.meta.title]"
    >
      <template slot="controls">
        <!-- <el-button type="primary" icon="el-icon-download" @click="handleExport">导出退货单</el-button> -->
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">订单状态：</label>
        <el-select
          placeholder="订单状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <label class="label">支付方式：</label>
        <el-select
          placeholder="支付方式"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.payId"
        >
          <el-option label="全部" :value="99"></el-option>
          <el-option
            v-for="(item, index) in payTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.start"
          style="width: 200px; margin-right: 5px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.end"
          style="width: 200px; margin-right: 5px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入订单号/客户名称"
          v-model="searchForm.name"
        >
        </el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          v-if="buttonVisibility.search"
          @click="getTableData('search')"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
      @expand-change="getOrderDetail"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="OrderNo"
        align="center"
        width="150"
        show-overflow-tooltip
        label="退款单号"
      >
      </el-table-column>
      <el-table-column
        prop="Thirdparty"
        align="center"
        width="220"
        show-overflow-tooltip
        label="交易单号"
      >
      </el-table-column>
      <el-table-column
        prop="AddTime"
        label="发起时间"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="BusinessName"
        label="单位名称"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="BusinessCode"
        label="单位编号"
        align="center"
        show-overflow-tooltip
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="PayType"
        label="支付方式"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="YOrderNo"
        label="原始单号"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="PayType"
        label="退款方式"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          prop="RetImg"
          label="凭证"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="scope.row.retImgList && scope.row.retImgList.length > 0" class="voucher-images">
                <div class="image-container">
                   <div 
                      class="image-item" 
                      v-for="(img, index) in scope.row.retImgList" 
                      :key="index"
                      @click.stop="previewImage(img.RetImg)"
                    >
                      <img :src="img.RetImg" alt="凭证图片" />
                    <div class="image-index">图{{ img.index }}</div>
                </div>
                </div>
              <div class="image-tip">点击图片可放大查看</div>
            </div>
            <div v-else class="no-images">
              暂无图片
            </div>
          </template>
      </el-table-column>
      <el-table-column
        prop="Remark"
        label="客户备注"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="TypeStatus"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.Status == 1">待审核</el-tag>
          <el-tag type="danger" v-else-if="scope.row.Status == 0"
            >已拒核</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.Status == 2"
            >已审核</el-tag
          >
          <el-tag type="info" v-else>未定义</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="TypeStatus"
        label="操作"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button type="text" 
            @click="getOrderDetail(scope)"
            v-if="buttonVisibility.details"
          >详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 商品表格 -->
    <el-dialog
      title="商品列表"
      :visible.sync="goodsDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="800px"
    >
      <el-table
        :data="details"
        stripe
        border
        height="300px"
        tooltip-effect="dark"
      >
        <el-table-column
          prop="GoodsName"
          label="商品名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="YQuantity"
          label="原单数量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="ReturnNum"
          label="已退数量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="ThQuantity"
          label="申请退货数量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <span v-if="selectRow.Status == 1" slot="footer" class="dialog-footer">
        <el-button 
          type="info"
          @click="handleRudit(0)"
        >拒审</el-button>
        <el-button
          type="success"
          @click="handleRudit(2)"
        >通过</el-button>
      </span>
    </el-dialog>
    <!-- 图片预览弹窗 -->
    <el-dialog :visible.sync="previewVisible" :close-on-click-modal="false" width="80%" top="5vh"
      class="image-preview-dialog">
      <div class="preview-content">
        <img :src="currentPreviewImage" alt="预览图片" class="preview-image" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="previewVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "returnList",
  data() {
    return {
      tableData: [],
       retImgList:[], //凭证图片 
      currentPreviewImage: "", //当前预览图片
      previewVisible: false, //图片预览弹窗是否显示
      options: [
        { value: "99", label: "全部" },
        { value: "0", label: "已拒审" },
        { value: "1", label: "待审核" },
        { value: "2", label: "已审核" },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        status: "99",
        name: "",
        payId: 99, //支付方式
        start: "", //起始日期
        end: "", //截止日期
      },

      /**支付方式 */
      payTypeList: [],

      /**退货详情 */
      details: [],
      goodsDialog: false,
      selectRow: {},
    };
  },
  computed: {
    // 按钮权限
    ...mapState(['buttonPermissions']),
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['退货审核'] || [];
      // console.log('buttonsLimit', buttonsLimit);
      return {
        search: buttonsLimit.includes('搜索'),
        details: buttonsLimit.includes('详情'),
      }
    }

  },
  mounted() {
    this.getTableData();
    this.getPayType();
  },
  methods: {
    /**获取支付方式id */
    getPayType() {
      let data = {
        entId: localStorage.getItem("entId"),
      };
      this.$request({
        url: "Base/GetEntPayTypeList",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.payTypeList = res.list.map((item) => ({
            label: item.PayType,
            value: item.PayId,
          }));
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },

    /**获取表格数据 */
    getTableData(type) {
      if (type == "refresh") {
        this.currPage = 1;
        this.searchForm.name = "";
        this.searchForm.start = "";
        this.searchForm.end = "";
        this.searchForm.payId = 99;
      } else if (type == "search") {
        this.currPage = 1;
      }

      let data = {
        status: this.searchForm.status,
        searchVal: this.searchForm.name,
        startData: this.searchForm.start,
        endData: this.searchForm.end,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
        payId: this.searchForm.payId,
      };

      this.$request({
        method: "post",
        url: "OrderAdmin/GetOrderReturnList",
        data,
      })
        .then((res) => {
          if (res.success) {
            this.tableData = res.dateList;
            this.allPage = res.toTal;
            if (this.tableData && this.tableData.length > 0) {
              this.tableData = this.tableData.map((item =>{
                if (item.RetImg && typeof item.RetImg == "string") {
                const imgUrls = item.RetImg.split(',').map(url => url.trim());
                const validImgUrls = imgUrls.filter(url => url.length > 0);
                return {
                  ...item,
                  retImgList: validImgUrls.map((imgUrl, index) => ({
                  RetImg: this.$setImgUrl(imgUrl),
                  index: index + 1
                  }))
                }
              }
              return {
                ...item,
                retImgList: []
              }
              }))
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**查询详情 */
    getOrderDetail({ row }) {
      this.selectRow = row;
      this.$request({
        method: "post",
        url: "/Management/OrderAdmin/GetOrderReturnDetail",
        data: {
          orderNo: row.OrderNo,
        },
      })
        .then((res) => {
          if (res.success) {
            this.goodsDialog = true;
            this.details = res.dateList;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**预览图片 */
    previewImage(imgUrl) {
      this.currentPreviewImage = imgUrl;
      this.previewVisible = true;
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**
     * 点击审核
     * 0 拒审 2 审核
     */
    handleRudit(type) {
      let tips = type == "0" ? "拒审" : "审核";

      this.$prompt("确定" + tips + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "备注",
      })
        .then(({ value }) => {
          this.$request({
            method: "post",
            url: "/Management/OrderAdmin/AutOrderReturn",
            data: {
              orderNo: this.selectRow.OrderNo,
              status: type,
              autMsg: value,
            },
          })
            .then((res) => {
              let type = "success";
              if (res.success) {
                type = "success";
                this.goodsDialog = false;
                this.getTableData();
              } else {
                type = "error";
              }
              this.$message({
                message: res.message,
                type: type,
              });
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    /**点击导出，暂时没有用到 */
    handleExport() {
      let startDate = "";
      let endDate = "";
      let status = this.searchForm.status;
      let txtStrWhere = this.searchForm.name;
      let userId = window.localStorage.getItem("userId");
      let entId = window.localStorage.getItem("entId");
      window.location.href =
        this.baseUrl +
        "/API/ToExcel/ToExceRefundOrderList?startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&status=" +
        status +
        "&strWhere=" +
        txtStrWhere +
        "&userId=" +
        userId +
        "&entId=" +
        entId;
    },
  },
};
</script>

<style scoped>
.returnList {
  width: 100%;
  height: 100%;
}
/* 凭证图片样式 */
.voucher-images {
  padding: 10px 0;
}

.image-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  justify-content: center;
}

.image-item {
  width: 60px;
  height: 60px;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ddd;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.image-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  border-color: #409EFF;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-index {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  text-align: center;
  font-size: 10px;
  padding: 1px 0;
  line-height: 1.2;
}

.image-tip {
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 5px;
}

.no-images {
  color: #999;
  font-style: italic;
  text-align: center;
  padding: 10px 0;
}

/* 图片预览弹窗样式 */
.preview-content {
  text-align: center;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
</style>
